import {
  DossierAnnexe,
  ErrorsByCategory,
  DossierError,
  BillDownloadStatus,
} from 'utils/__interfaces/Billings/BillEntity'
import BillingDownloadErrorNormalizer from './BillingDownloadErrorNormalizer'

export default class BillingAnnexeDownloadErrorNormalizer {
  static normalize(
    fileErrorList: BillDownloadStatus[],
    dossiers: DossierAnnexe
  ): ErrorsByCategory {
    const downloadKOCategorizedErrors = BillingDownloadErrorNormalizer.normalize(
      fileErrorList
    )

    const allErrorsCategorized = Object.keys(
      downloadKOCategorizedErrors
    ).reduce<ErrorsByCategory>((categorized, setName) => {
      // setName are error types names such as 'unavailable', 'technical'
      const sortedErrors = downloadKOCategorizedErrors[setName].reduce<
        DossierError
      >((setErrors, setErrorItem) => {
        // keys of dossiers are dossier number
        // values for each keys (i.e. 'dossiers[item]') are file technical id
        let nextErrorSet = { ...setErrors }
        Object.keys(dossiers).forEach((item) => {
          nextErrorSet = dossiers[item].includes(setErrorItem.id)
            ? {
                ...nextErrorSet,
                [item]: nextErrorSet[item]
                  ? nextErrorSet[item].concat(setErrorItem)
                  : (nextErrorSet[item] = [setErrorItem]),
              }
            : { ...nextErrorSet }
        })
        return nextErrorSet
      }, {})
      return { ...categorized, [setName]: sortedErrors }
    }, {})

    const allErrorsCategorizedSortedById: ErrorsByCategory = {}
    Object.entries(allErrorsCategorized).forEach(([i, values]) => {
      const sortedValues = Object.keys(values)
        .sort()
        .reduce((sorted, key) => {
          return { ...sorted, [key]: values[key] }
        }, {})
      allErrorsCategorizedSortedById[i] = sortedValues
    })

    return allErrorsCategorizedSortedById
  }
}
